import React, { useEffect } from "react";
import Logo from "../atoms/Logo";
import CartIcon from "../../images/icons/CartIcon";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { isLoggedIn } from "../privateRoute";
import LogoutButton from "../atoms/LogoutButton";
import LoginButton from "../atoms/LoginButton";
import CollectionsInHeader from "../molecules/CollectionsInHeader";
import { useUser } from "../../context/UserContext";
import Search from "../searchContainer/Search";

export default function Header() {
  const cartItemsCounter = useUser((state) => state.cartItemsCounter);

  const {exist: loggedIn, displayName} = isLoggedIn();

  useEffect(() => {
  }, [loggedIn, cartItemsCounter]);

  return (
    <header className="flex flex-col md:flex-row w-full items-center bg-primary text-white items-center sticky top-0 z-10 md:h-40">
      <Link to="/" className="flex justify-center w-full">
        <Logo />
      </Link>

      <div className="flex flex-col w-full items-center justify-center h-full grow">
        <div
          className="flex rounded-md
         bg-white w-4/5 mb-2 "
        >
          <StaticImage
            src="../../images/icons/SearchIcon.png"
            alt="Search "
            placeholder="blurred"
            className="h-4 w-4 m-1"
          />
          <Search/>
        </div>
        <div className="flex md:flex-col w-full items-center justify-center md:mt-2">
          <div className="flex justify-between md:justify-evenly w-4/5 items-center">
            {loggedIn 
            ? <div className="flex justify-evenly flex-col text-xs">
                <h3 className="pr-2">{displayName}</h3>
                <LogoutButton /> 
              </div>
            : <LoginButton />}
            <Link to="/products">Productos</Link>

            <div className="flex items-center justify-center">
              <a
                href="https://www.google.com.mx/maps/place/Ferreplomer%C3%ADa+Promaco/@28.6595372,-106.0997674,19.64z/data=!4m5!3m4!1s0x8694512721dd575d:0xa3581c7521149f39!8m2!3d28.6596671!4d-106.099737?hl=es-419&authuser=0"
                className="mr-2"
              >
                Dirección
              </a>
              <Link to="/Checkout" className="flex gap-1 items-center">
                <CartIcon width="25" height="22" fill="white" />
                {cartItemsCounter}
              </Link>
            </div>
          </div>
          <CollectionsInHeader />
        </div>
      </div>
    </header>
  );
}
